(function ($) {
	'use strict';

	$(function () {
		const token = $('meta[name="csrf-token"]').attr('content');
		let currentPayload = null;
		let selectedVacancy = null;

		function escapeHtml(value) {
			return String(value || '').replace(/[&<>"']/g, function (char) {
				return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;'}[char];
			});
		}

		function modal() {
			let $modal = $('[data-offer-modal]');
			if ($modal.length) return $modal;

			$modal = $(
				'<div class="offer-vacancy-modal" data-offer-modal role="dialog" aria-modal="true" aria-labelledby="offer-vacancy-title">' +
					'<div class="offer-vacancy-modal__dialog">' +
						'<div class="offer-vacancy-modal__header">' +
							window.___('<div><h3 id="offer-vacancy-title">Запропонувати вакансію</h3><p data-offer-subtitle>Оберіть вакансію, яку хочете запропонувати цьому кандидату.</p></div>') +
							window.___('<button type="button" class="offer-vacancy-modal__close" data-offer-close aria-label="Закрити"><i class="uil uil-times"></i></button>') +
						'</div>' +
						'<div class="offer-vacancy-modal__body" data-offer-body></div>' +
						'<div class="offer-vacancy-modal__footer" data-offer-footer></div>' +
					'</div>' +
				'</div>'
			).appendTo('body');

			return $modal;
		}

		function nextFrame(callback) {
			if (window.requestAnimationFrame) {
				window.requestAnimationFrame(function () {
					window.requestAnimationFrame(callback);
				});
			} else {
				setTimeout(callback, 20);
			}
		}

		function openModal() {
			const $modal = modal();
			$('body').addClass('offer-vacancy-modal-open');
			$modal.removeClass('is-closing is-open');
			nextFrame(function () {
				$modal.addClass('is-open');
			});
		}

		function closeModal() {
			const $modal = modal();
			$modal.addClass('is-closing').removeClass('is-open');
			setTimeout(function () {
				$modal.removeClass('is-closing');
				$('body').removeClass('offer-vacancy-modal-open');
			}, 200);
		}

		function messageState(title, text, actions) {
			const $modal = modal();
			$modal.find('#offer-vacancy-title').text(title);
			$modal.find('[data-offer-subtitle]').text(text || '');
			$modal.find('[data-offer-body]').empty();
			const $footer = $modal.find('[data-offer-footer]').empty();

			(actions || [{label: window.___('Закрити'), className: 'employer-btn employer-btn--outline', click: closeModal}]).forEach(function (action) {
				const $el = action.href ? $('<a></a>').attr('href', action.href) : $('<button type="button"></button>').on('click', action.click || closeModal);
				$el.addClass(action.className || 'employer-btn employer-btn--outline').text(action.label).appendTo($footer);
			});

			openModal();
		}

		function vacancyLine(vacancy) {
			return [vacancy.city, vacancy.work_format].filter(Boolean).join(' / ');
		}

		function renderPreview(vacancy) {
			if (!vacancy) {
				$('[data-offer-preview]').html(window.___('<div class="offer-vacancy-preview__empty">Оберіть вакансію, щоб побачити короткий перегляд.</div>'));
				return;
			}

			const meta = [
				vacancy.city,
				vacancy.work_format,
				vacancy.employment_type,
				vacancy.salary,
				vacancy.updated ? window.___('Оновлено ') + vacancy.updated : null
			].filter(Boolean);

			$('[data-offer-preview]').html(
				'<div class="offer-vacancy-preview__card">' +
					'<h4>' + escapeHtml(vacancy.title) + '</h4>' +
					'<strong>' + escapeHtml(vacancy.company) + '</strong>' +
					'<p>' + escapeHtml(meta.join(' · ')) + '</p>' +
					'<a href="' + escapeHtml(vacancy.url) + window.___('" target="_blank" rel="noopener">Переглянути вакансію</a>') +
				'</div>'
			);
		}

		function selectVacancy(vacancyId) {
			selectedVacancy = (currentPayload.vacancies || []).find(function (vacancy) {
				return String(vacancy.id) === String(vacancyId);
			}) || null;

			$('[data-offer-vacancy-id]').val(selectedVacancy ? selectedVacancy.id : '');
			$('[data-offer-vacancy-option]').removeClass('is-selected');
			$('[data-offer-vacancy-option][data-id="' + vacancyId + '"]').addClass('is-selected');
			$('[data-offer-submit]').prop('disabled', !selectedVacancy);
			renderPreview(selectedVacancy);
		}

		function renderReady(data) {
			currentPayload = data;
			selectedVacancy = null;
			const $modal = modal();
			const candidateMeta = [data.candidate.roles, data.candidate.cities, data.candidate.experience, data.candidate.salary].filter(Boolean).join(' · ');
			const options = (data.vacancies || []).map(function (vacancy) {
				const disabled = vacancy.offered || vacancy.applied;
				const badge = vacancy.offered ? window.___('Вже запропоновано') : (vacancy.applied ? window.___('Кандидат вже відгукнувся') : '');
				return '<button type="button" class="offer-vacancy-option' + (disabled ? ' is-disabled' : '') + '" data-offer-vacancy-option data-id="' + vacancy.id + '"' + (disabled ? ' disabled' : '') + '>' +
					'<span><strong>' + escapeHtml(vacancy.title) + '</strong><small>' + escapeHtml([vacancyLine(vacancy), vacancy.salary].filter(Boolean).join(' · ')) + '</small></span>' +
					(badge ? '<em>' + escapeHtml(badge) + '</em>' : '<i class="uil uil-angle-right-b"></i>') +
				'</button>';
			}).join('');

			$modal.find('#offer-vacancy-title').text(window.___('Запропонувати вакансію'));
			$modal.find('[data-offer-subtitle]').text(window.___('Оберіть вакансію, яку хочете запропонувати цьому кандидату.'));
			$modal.find('[data-offer-body]').html(
				'<form data-offer-form data-store-url="' + escapeHtml(data.store_url) + '">' +
					'<section class="offer-vacancy-section offer-vacancy-candidate">' +
						'<h4>' + escapeHtml(data.candidate.title || window.___('Резюме кандидата')) + '</h4>' +
						(candidateMeta ? '<p>' + escapeHtml(candidateMeta) + '</p>' : '') +
					'</section>' +
					'<section class="offer-vacancy-section">' +
						window.___('<div class="offer-vacancy-section__head"><h4>Вакансія</h4><p>Оберіть одну з активних опублікованих вакансій.</p></div>') +
						'<input type="hidden" name="vacancy_id" data-offer-vacancy-id>' +
						window.___('<input type="search" class="offer-vacancy-search" data-offer-search placeholder="Пошук за назвою вакансії">') +
						'<div class="offer-vacancy-options">' + options + '</div>' +
						'<div class="offer-vacancy-error" data-offer-error></div>' +
					'</section>' +
					'<section class="offer-vacancy-section">' +
						window.___('<div class="offer-vacancy-section__head"><h4>Попередній перегляд</h4></div>') +
						'<div class="offer-vacancy-preview" data-offer-preview></div>' +
					'</section>' +
					'<section class="offer-vacancy-section">' +
						window.___('<label class="offer-vacancy-field"><span>Повідомлення кандидату</span><textarea name="message" maxlength="1000" class="js-offer-message" placeholder="Напишіть коротко, чому ця вакансія може зацікавити кандидата"></textarea></label>') +
						window.___('<div class="offer-vacancy-help">Коротке персональне повідомлення підвищує шанс відповіді кандидата. <b data-offer-message-count>0 / 1000</b></div>') +
					'</section>' +
				'</form>'
			);
			$modal.find('[data-offer-footer]').html(
				window.___('<button type="button" class="employer-btn employer-btn--outline" data-offer-close>Скасувати</button>') +
				window.___('<button type="button" class="employer-btn employer-btn--primary" data-offer-submit disabled>Надіслати пропозицію</button>')
			);

			renderPreview(null);
			openModal();
		}

		$(document).on('click', '.js-offer-vacancy-open', function (event) {
			event.preventDefault();
			const $button = $(this);
			const url = $button.data('modal-url');
			if (!url) return;

			$button.prop('disabled', true).addClass('is-loading');
			$.ajax({url: url, method: 'GET', dataType: 'json', headers: {'Accept': 'application/json'}})
				.done(function (response) {
					if (response.state === 'no_vacancies') {
						messageState(window.___('У вас поки немає активних вакансій'), window.___('Створіть або опублікуйте вакансію, щоб запропонувати її кандидату.'), [
							{label: window.___('Створити вакансію'), href: response.create_url, className: 'employer-btn employer-btn--primary'},
							{label: window.___('Закрити'), className: 'employer-btn employer-btn--outline', click: closeModal}
						]);
					} else if (response.state === 'all_offered') {
						messageState(window.___('Усі активні вакансії вже запропоновано'), window.___('Ви вже запропонували цьому кандидату всі активні вакансії.'), [
							{label: window.___('Переглянути мої вакансії'), href: response.vacancies_url, className: 'employer-btn employer-btn--primary'},
							{label: window.___('Закрити'), className: 'employer-btn employer-btn--outline', click: closeModal}
						]);
					} else if (response.state === 'ready') {
						renderReady(response);
					}
				})
				.fail(function () {
					messageState(window.___('Не вдалося відкрити пропозицію'), window.___('Спробуйте ще раз або оновіть сторінку.'));
				})
				.always(function () {
					$button.prop('disabled', false).removeClass('is-loading');
				});
		});

		$(document).on('click', '[data-offer-close]', closeModal);
		$(document).on('click', '[data-offer-modal]', function (event) {
			if (event.target === this) closeModal();
		});
		$(document).on('keydown', function (event) {
			if (event.key === 'Escape' && $('[data-offer-modal]').hasClass('is-open')) closeModal();
		});
		$(document).on('click', '[data-offer-vacancy-option]', function () {
			if ($(this).prop('disabled')) return;
			selectVacancy($(this).data('id'));
		});
		$(document).on('input', '[data-offer-search]', function () {
			const query = ($(this).val() || '').toLowerCase();
			$('[data-offer-vacancy-option]').each(function () {
				$(this).toggle($(this).text().toLowerCase().indexOf(query) !== -1);
			});
		});
		$(document).on('input', '.js-offer-message', function () {
			$('[data-offer-message-count]').text(($(this).val() || '').length + ' / 1000');
		});
		$(document).on('click', '[data-offer-submit]', function () {
			const $button = $(this);
			const $form = $('[data-offer-form]');
			const vacancyId = $form.find('[data-offer-vacancy-id]').val();
			if (!vacancyId) return;

			$button.prop('disabled', true).text(window.___('Надсилаємо...'));
			$('[data-offer-error]').removeClass('is-visible').text('');
			$.ajax({
				url: $form.data('store-url'),
				method: 'POST',
				dataType: 'json',
				headers: {'X-CSRF-TOKEN': token, 'Accept': 'application/json'},
				data: {
					vacancy_id: vacancyId,
					message: $form.find('textarea[name="message"]').val()
				}
			}).done(function () {
				messageState(window.___('Пропозицію надіслано'), window.___('Кандидат побачить вашу вакансію у своєму профілі.'), [
					{label: window.___('Закрити'), className: 'employer-btn employer-btn--primary', click: closeModal},
					{label: window.___('Перейти до резюме'), href: currentPayload.resume_url, className: 'employer-btn employer-btn--outline'}
				]);
			}).fail(function (xhr) {
				let message = window.___('Не вдалося надіслати пропозицію. Спробуйте ще раз або оновіть сторінку.');
				if (xhr.status === 422 && xhr.responseJSON && xhr.responseJSON.errors) {
					message = Object.values(xhr.responseJSON.errors)[0][0] || message;
				}
				$('[data-offer-error]').text(message).addClass('is-visible');
				$button.prop('disabled', false).text(window.___('Надіслати пропозицію'));
			});
		});
	});
})(jQuery);
